import React, { Component } from "react";
import Typography from "@material-ui/core/Typography";
import { inject, observer } from "mobx-react";
import { withRouter } from "react-router-dom";

import { Paper, TextField, FormControl, InputLabel, Grid, FormControlLabel, Checkbox, Button, Switch, IconButton, Collapse, MenuItem, Select, Tooltip } from "@material-ui/core";
import Slider from "@material-ui/lab/Slider";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import StarIcon from "@material-ui/icons/Star";

import MomentUtils from "@date-io/moment";
import { MuiPickersUtilsProvider } from "material-ui-pickers";
import { DatePicker } from "material-ui-pickers";

import moment from "moment";

import Instruments from "../fields/MultiSelectInstrument";

import Genre from "../fields/MultiSelectGenre";
import GigType from "../fields/MultiSelectGigTypes";

import SelectField from "../fields/SelectField";
import GooglePlaceAutoComplete from "../maps/GooglePlaceAutocomplete";

import EventIcon from "@material-ui/icons/Event";
import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import { ProfileType } from "../../types/enum";
import HubTimepicker from "../timepicker/HubTimepicker";

import agent from "../../agent";

@inject("searchStore", "profileStore", "actTypeStore")
@withRouter
@observer
class SearchFilter extends Component {
    state = {
        searchTimeout: undefined,
        vibes: [],
        showAdvanced: false
    };

    componentDidMount() {
        this.props.searchStore.setPage(1);
        this.props.actTypeStore.loadActTypes();
        if (this.props.location.search) {
            this.props.searchStore.setSearch(this.props.location.search);
        }

        agent.Vibe.getAll().then(result => {
            this.setState({
                vibes: result.map(vibes => ({
                    value: vibes.id,
                    label: vibes.name
                }))
            });
        });
    }

    hasActiveAdvancedFilters = () => {
        const { song, instruments, setRequiredDateTime, newActsWeeks } = this.props.searchStore;
        return !!(song || (instruments && instruments.length > 0) || setRequiredDateTime || newActsWeeks);
    }
    refreshSearch() {
        if (this.state.searchTimeout) {
            clearTimeout(this.state.searchTimeout);
        }
        //this.state.searchTimeout = setTimeout(this.props.searchStore.search, 1000);
    }

    handleTypeChange = value => {
        this.props.searchStore.setType(value);
        this.setState({ ...this.state });
    };

    handleQueryChange = e => {
        this.props.searchStore.setQuery(e.target.value);
        // this.refreshSearch();
    };
    handleSongChange = e => this.props.searchStore.setSong(e.target.value);
    handleInstrumentChange = value => this.props.searchStore.setInstruments(value);
    handleGenreChange = value => this.props.searchStore.setGenres(value);
    handleGigTypeChange = value => this.props.searchStore.setGigTypes(value);
    handleCityChange = e => this.props.searchStore.setCity(e.target.value);
    handleStateChange = e => this.props.searchStore.setState(e.target.value);
    handleLineUpCountChange = value => this.props.searchStore.setLineUpCount(value);
    handleChangeSearchAddress = value => {
        this.props.searchStore.setSearchedAddress(value);
    };
    handleChangeLongitudeLatitude = value => this.props.searchStore.setLocationLongitudeLatitude(value);
    handleChangeDistanceRadius = (event, value) => this.props.searchStore.setDistanceRadius(value);
    handleRequiredDate = value => this.props.searchStore.setRequiredDate(value);
    handleSetRequiredDateTimeOption = event => {
        this.props.searchStore.setRequiredDateTimeOption(event.target.checked);
    };
    handleSetRequiredTimeStart = value => this.props.searchStore.setRequiredTimeStart(value);
    handleSetRequiredTimeEnd = value => this.props.searchStore.setRequiredTimeEnd(value);
    handleActTypeChange = value => this.props.searchStore.setActTypeId(value);

    handleSubmitSearch = e => {
        e.preventDefault();
        this.props.searchStore.submitSearch();
    };

    handleApplyToPlay = e => this.props.searchStore.setIsApplyToPlay(e.target.checked);
    handleApplyToBook = e => this.props.searchStore.setIsApplyToBook(e.target.checked);

    handleApplyActRoster = e => this.props.searchStore.setIsApplyToActRoster(e.target.checked);
    handleVibeChange = value => this.props.searchStore.setSelectedVibes(value);
    handleNewActsWeeksChange = e => {
        this.props.searchStore.setNewActsWeeks(e.target.value);
        this.props.searchStore.submitSearch();
    };
    handleSortByChange = e => this.props.searchStore.setSortBy(e.target.value);
    handleClearFilters = () => {
        this.props.searchStore.clearFilters();
        this.props.searchStore.submitSearch();
    };
    toggleAdvanced = () => {
        const hasFilters = this.hasActiveAdvancedFilters();
        if (hasFilters) {
            return;
        }
        this.setState({ showAdvanced: !this.state.showAdvanced });
    };

    lineUpCountSuggestion = () => {
        let lineUpCounts = [
            { name: "Solo", instrument: 1 },
            { name: "Duo", instrument: 2 },
            { name: "Trio", instrument: 3 },
            { name: "Quartet / 4 Piece", instrument: 4 },
            { name: "Quintet / 5 Piece", instrument: 5 },
            { name: "Sextet / 6 Piece", instrument: 6 }
        ];

        for (var i = 0; i < 93; i++) {
            lineUpCounts.push({ name: i + 7 + " Piece", instrument: i + 7 });
        }
        return lineUpCounts.map(lineUpCount => {
            return {
                value: lineUpCount.instrument,
                label: lineUpCount.name
            };
        });
    };

    vibeSuggestion = () => {
        const { vibes } = this.state;
        return vibes.map(vibe => {
            
            return vibe;
        });
    }

    getProfileTypeSuggestions = () => {
        const currentProfile = this.props.profileStore.getCurrentProfile()

        if (currentProfile?.type === ProfileType.Musician.ordinal ||
            currentProfile?.type === ProfileType.Agent.ordinal 
        ) {
            return [
                { value: 4, label: "Act / Band" },
                { value: 1, label: "Musician / DJ / Entertainer" },
                { value: 5, label: "Venue" },
                { value: 2, label: "Agent" }
            ];
        } else if (currentProfile?.type === ProfileType.PrivateHire.ordinal){
            return [{ value: 4, label: "Act / Band" }]
        }else {
            return [{ value: 4, label: "Act / Band" }, { value: 5, label: "Venue" }, { value: 2, label: "Agent" }];
        }
    };

    render() {
        const {
            query,
            song,
            // type,
            lineUpCount,
            instruments,
            genres,
            gigTypes,
            searchedAddress,
            locationLongitudeLatitude,
            distanceRadius,
            setRequiredDateTime,
            requiredDate,
            requiredTimeStart,
            requiredTimeEnd,
            actTypeId,
            isApplyToPlay,
            isApplyToActRoster,
            selectedVibes,
            isApplyToBook,
            newActsWeeks,
            sortBy
        } = this.props.searchStore;
        const type = this.props.searchStore.type;
        const { showAdvanced } = this.state
        const { actTypes } = this.props.actTypeStore;

        let actTypeSuggestion = () => {
            return actTypes.map(actType => {
                return {
                    value: actType.id,
                    label: actType.name
                };
            });
        };

        const currentProfile = this.props.profileStore.getCurrentProfile();

        const { hideHeader } = this.props;

        return (
            <Paper style={{ padding: 20, borderRadius: 8 }}>
                <form onSubmit={this.handleSubmitSearch}>
                    <Grid container spacing={16} alignItems="flex-start">
                        <Grid item xs={12} sm={6} md={3}>
                            <TextField id="query" label="Name" margin="dense" fullWidth value={query} onChange={this.handleQueryChange} />
                        </Grid>
                        {type && type === 4 ? (
                            <Grid item xs={12} sm={6} md={3}>
                                <SelectField
                                    id="actTypeId"
                                    multi={true}
                                    suggestions={actTypeSuggestion()}
                                    onChange={this.handleActTypeChange}
                                    value={actTypeId}
                                    placeholder=" "
                                    label="Act Type"
                                    margin="dense"
                                />
                            </Grid>
                        ) : null}
                        {type && type === 4 ? (
                            <Grid item xs={12} sm={6} md={3}>
                                <SelectField
                                    id="lineUpCount"
                                    multi={false}
                                    suggestions={this.lineUpCountSuggestion()}
                                    onChange={this.handleLineUpCountChange}
                                    value={lineUpCount}
                                    placeholder=" "
                                    label="Line Up"
                                    margin="dense"
                                />
                            </Grid>
                        ) : null}
                        {type && type === 1 ? (
                            <Grid item xs={12} sm={6} md={3}>
                                <GigType id="search-gigTypes" onChange={this.handleGigTypeChange} value={gigTypes} />
                            </Grid>
                        ) : null}
                        {type && type === 1 ? (
                            <Grid item xs={12} sm={6} md={3}>
                                <Genre id="search-genres" onChange={this.handleGenreChange} value={genres} />
                            </Grid>
                        ) : null}
                        <Grid item xs={12} sm={6} md={3}>
                            <GooglePlaceAutoComplete
                                value={searchedAddress}
                                label="Search Address"
                                placeholder="Type venue name or address"
                                handleChange={this.handleChangeSearchAddress}
                                handleChangeCity={this.handleCityChange}
                                handleChangeState={this.handleStateChange}
                                handleChangeLatLng={this.handleChangeLongitudeLatitude}
                                style={{ marginTop: "8px" }}
                            />
                        </Grid>
                        {type && type === 4 ? (
                            <Grid item xs={12} sm={6} md={3}>
                                <GigType id="search-gigTypes" onChange={this.handleGigTypeChange} value={gigTypes} />
                            </Grid>
                        ) : null}
                        {type && type === 4 ? (
                            <Grid item xs={12} sm={6} md={3}>
                                <Genre id="search-genres" onChange={this.handleGenreChange} value={genres} />
                            </Grid>
                        ) : null}
                        {type && type === 4 ? (
                            <Grid item xs={12} sm={6} md={3}>
                                <SelectField
                                    id="vibes"
                                    multi={true}
                                    suggestions={this.vibeSuggestion()}
                                    onChange={this.handleVibeChange}
                                    value={selectedVibes}
                                    placeholder=" "
                                    label="Vibes"
                                    margin="dense"
                                />
                            </Grid>
                        ) : null}
                        {locationLongitudeLatitude ? (
                            <Grid item xs={12} sm={6} md={3}>
                                <FormControl fullWidth style={{ marginTop: 8 }}>
                                    <InputLabel shrink>
                                        Distance {distanceRadius ? `: ${distanceRadius} Km` : ""}
                                    </InputLabel>
                                    <div style={{ height: 30, marginTop: 32, paddingLeft: 4 }}>
                                        <Slider
                                            value={distanceRadius}
                                            min={0}
                                            max={500}
                                            step={1}
                                            onChange={this.handleChangeDistanceRadius}
                                        />
                                    </div>
                                </FormControl>
                            </Grid>
                        ) : null}
                        {type && type === 5 && currentProfile?.type === ProfileType.Musician.ordinal && (
                            <Grid item xs={12} md={3}>
                                <Paper 
                                    elevation={0}
                                    style={{ 
                                        background: "linear-gradient(135deg, #fff5fb 0%, #fff 100%)",
                                        border: "2px solid #ff0c9c",
                                        borderRadius: 8,
                                        padding: "12px 16px",
                                        marginTop: 8
                                    }}
                                >
                                    <div style={{ display: "flex", alignItems: "center" }}>
                                        <Switch checked={isApplyToPlay} onChange={this.handleApplyToPlay} color="primary" />
                                        <span style={{ fontWeight: 500 }}>Apply to Play</span>
                                    </div>
                                    <Typography variant="caption" style={{ color: "#888", marginLeft: 42 }}>
                                        Show only venues accepting artist applications
                                    </Typography>
                                </Paper>
                            </Grid>
                        )}
                        {type && type === ProfileType.Venue.ordinal && currentProfile?.type === ProfileType.Agent.ordinal && (
                            <Grid item xs={12} md={3}>
                                <Paper 
                                    elevation={0}
                                    style={{ 
                                        background: "linear-gradient(135deg, #fff5fb 0%, #fff 100%)",
                                        border: "2px solid #ff0c9c",
                                        borderRadius: 8,
                                        padding: "12px 16px",
                                        marginTop: 8
                                    }}
                                >
                                    <div style={{ display: "flex", alignItems: "center" }}>
                                        <Switch checked={isApplyToBook} onChange={this.handleApplyToBook} color="primary" />
                                        <span style={{ fontWeight: 500 }}>Apply to Book</span>
                                    </div>
                                    <Typography variant="caption" style={{ color: "#888", marginLeft: 42 }}>
                                        Show only venues accepting booking requests from agents
                                    </Typography>
                                </Paper>
                            </Grid>
                        )}
                        {
                          type &&  type === ProfileType.Agent.ordinal  && currentProfile?.type === ProfileType.Musician.ordinal && (
                                <Grid item xs={12} md={3}>
                                    <Grid item>
                                        <div>
                                            <Switch checked={isApplyToActRoster} onChange={this.handleApplyActRoster} color="primary" />{" "}
                                            Apply to Play
                                        </div>
                                    </Grid>
                                </Grid>
                            )
                        }

                    </Grid>

                    {(() => {
                        const hasAdvancedFilters = this.hasActiveAdvancedFilters();
                        const isOpen = showAdvanced || hasAdvancedFilters;
                        return (
                            <>
                                <div 
                                    onClick={this.toggleAdvanced}
                                    style={{ 
                                        display: "flex", 
                                        alignItems: "center", 
                                        gap: 8, 
                                        color: hasAdvancedFilters ? "#ff0c9c" : "#666", 
                                        fontSize: 13, 
                                        cursor: "pointer",
                                        padding: "12px 0",
                                        marginTop: 8,
                                        fontWeight: hasAdvancedFilters ? 500 : 400
                                    }}
                                >
                                    {isOpen ? <ExpandLessIcon style={{ fontSize: 18 }} /> : <ExpandMoreIcon style={{ fontSize: 18 }} />}
                                    <span>Advanced Filters</span>
                                    {hasAdvancedFilters && (
                                        <span style={{ 
                                            background: "#ff0c9c", 
                                            color: "white", 
                                            borderRadius: 10, 
                                            padding: "2px 8px", 
                                            fontSize: 11,
                                            marginLeft: 4
                                        }}>Active</span>
                                    )}
                                </div>

                                <Collapse in={isOpen}>
                                    <Grid container spacing={16} alignItems="flex-end" style={{ marginBottom: 16, marginTop: 8 }}>
                                        {type && type === 4 && (
                                            <Grid item xs={12} sm={6} md={3}>
                                                <FormControl fullWidth margin="dense">
                                                    <InputLabel shrink>Show New Acts</InputLabel>
                                                    <Select
                                                        value={newActsWeeks || ""}
                                                        onChange={this.handleNewActsWeeksChange}
                                                        displayEmpty
                                                        style={{ marginTop: 16 }}
                                                    >
                                                        <MenuItem value="">All Acts</MenuItem>
                                                        <MenuItem value="1">Added in last week</MenuItem>
                                                        <MenuItem value="2">Added in last 2 weeks</MenuItem>
                                                        <MenuItem value="4">Added in last 4 weeks</MenuItem>
                                                        <MenuItem value="8">Added in last 8 weeks</MenuItem>
                                                        <MenuItem value="12">Added in last 3 months</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                        )}
                                        {(type === 1 || type === 4) && (
                                            <Grid item xs={12} sm={6} md={3}>
                                                <TextField 
                                                    id="song" 
                                                    label="Song Title" 
                                                    margin="dense" 
                                                    fullWidth 
                                                    value={song} 
                                                    onChange={this.handleSongChange}
                                                    placeholder="Search by song title..."
                                                />
                                            </Grid>
                                        )}
                                        {(type === 1 || type === 4) && (
                                            <Grid item xs={12} sm={6} md={3}>
                                                <Instruments
                                                    id="search-instruments-advanced"
                                                    onChange={this.handleInstrumentChange}
                                                    value={instruments}
                                                    placeholder="Select Instruments"
                                                    label="Instruments/Skill Sets"
                                                />
                                            </Grid>
                                        )}
                                    </Grid>
                                    {(type === 4 || type === 1) && (
                                        currentProfile?.type === ProfileType.Agent.ordinal ||
                                        currentProfile?.type === ProfileType.Staff.ordinal ||
                                        currentProfile?.type === ProfileType.Musician.ordinal
                                    ) && (
                                        <Grid container spacing={16} alignItems="flex-end" style={{ marginBottom: 8 }}>
                                            <Grid item xs={12} sm={6} md={3}>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            color="primary"
                                                            checked={setRequiredDateTime}
                                                            onChange={this.handleSetRequiredDateTimeOption}
                                                        />
                                                    }
                                                    label="Set Required Date/Time"
                                                    style={{ marginBottom: 4 }}
                                                />
                                            </Grid>
                                            {setRequiredDateTime && (
                                                <>
                                                    <Grid item xs={12} sm={6} md={3}>
                                                        <MuiPickersUtilsProvider utils={MomentUtils}>
                                                            <DatePicker
                                                                id="search-required-date-advanced"
                                                                keyboard
                                                                value={requiredDate || null}
                                                                onChange={this.handleRequiredDate}
                                                                label="Required Date"
                                                                format="DD-MM-YYYY"
                                                                fullWidth
                                                                margin="dense"
                                                                clearable
                                                                minDate={moment().startOf("day")}
                                                                leftArrowIcon={<KeyboardArrowLeftIcon />}
                                                                rightArrowIcon={<KeyboardArrowRightIcon />}
                                                                keyboardIcon={<EventIcon />}
                                                            />
                                                        </MuiPickersUtilsProvider>
                                                    </Grid>
                                                    <Grid item xs={6} sm={3} md={3}>
                                                        <HubTimepicker
                                                            id="time-start-advanced"
                                                            margin="dense"
                                                            label="Time Start"
                                                            value={moment(requiredTimeStart, "HH:mm")}
                                                            onChange={this.handleSetRequiredTimeStart}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={6} sm={3} md={3}>
                                                        <HubTimepicker
                                                            id="time-end-advanced"
                                                            margin="dense"
                                                            label="Time End"
                                                            value={moment(requiredTimeEnd, "HH:mm")}
                                                            onChange={this.handleSetRequiredTimeEnd}
                                                        />
                                                    </Grid>
                                                </>
                                            )}
                                        </Grid>
                                    )}
                                </Collapse>
                            </>
                        );
                    })()}

                    <div style={{ 
                        display: "flex", 
                        justifyContent: "flex-end", 
                        gap: 10, 
                        paddingTop: 15, 
                        borderTop: "1px solid #eee",
                        marginTop: 8
                    }}>
                        <Button
                            variant="outlined"
                            onClick={this.handleClearFilters}
                            style={{ 
                                borderColor: "#ddd",
                                color: "#666",
                                textTransform: "none"
                            }}
                        >
                            Clear All
                        </Button>
                        <Button
                            variant="contained"
                            onClick={this.handleSubmitSearch}
                            type="submit"
                            style={{ 
                                background: "#ff0c9c",
                                color: "white",
                                textTransform: "none"
                            }}
                        >
                            Search
                        </Button>
                    </div>
                </form>
            </Paper>
        );
    }
}

export default SearchFilter;
